module.exports = __webpack_public_path__ + "static/media/redbull_logo_720.a1ba4fdd.png";